import React, { useEffect, useMemo, useState } from 'react';
import { Card, Table, Input, Tag, Space, Typography } from 'antd';
import { superadminApi } from '../../services/superadminApi';

const { Title, Text } = Typography;

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [q, setQ] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const [cs, as] = await Promise.all([
          superadminApi.listCompanies(),
          superadminApi.listAdmins?.() || Promise.resolve([]),
        ]);
        if (!mounted) return;
        setCompanies(cs || []);
        setAdmins(as || []);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const rows = useMemo(() => {
    // Build list from company owners + admin users
    const owners = (companies || []).map(c => ({
      key: `owner:${c._id || c.id}`,
      name: c.ownerName,
      email: c.ownerEmail,
      role: 'Owner',
      company: c.name,
      status: c.status || 'pending',
      source: 'company',
    }));
    const adminRows = (admins || []).map(a => ({
      key: `admin:${a.id || a._id}`,
      name: a.name,
      email: a.email,
      role: a.role || 'superadmin',
      company: '-',
      status: 'active',
      source: 'admin',
    }));
    // De-duplicate by email preferring admin accounts
    const byEmail = new Map();
    [...owners, ...adminRows].forEach(u => {
      const existing = byEmail.get(u.email);
      if (!existing || (u.source === 'admin' && existing.source !== 'admin')) {
        byEmail.set(u.email, u);
      }
    });
    let arr = Array.from(byEmail.values());
    if (q) {
      const qq = q.toLowerCase();
      arr = arr.filter(u => (u.name || '').toLowerCase().includes(qq) || (u.email || '').toLowerCase().includes(qq) || (u.company || '').toLowerCase().includes(qq));
    }
    return arr;
  }, [companies, admins, q]);

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Role', dataIndex: 'role', key: 'role', render: (v) => <Tag color={v === 'superadmin' ? 'magenta' : 'blue'}>{v}</Tag> },
    { title: 'Company', dataIndex: 'company', key: 'company' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'active' ? 'green' : s === 'pending' ? 'orange' : 'red'}>{s}</Tag> },
  ];

  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div className="flex items-center justify-between">
          <Title level={3} className="!mb-0">Users</Title>
          <Input.Search placeholder="Search users" onSearch={setQ} onChange={(e) => setQ(e.target.value)} allowClear style={{ maxWidth: 300 }} />
        </div>
        <Text type="secondary">All registered users, including company owners and superadmin accounts.</Text>
        <Table
          rowKey="key"
          loading={loading}
          columns={columns}
          dataSource={rows}
          pagination={{ pageSize: 10 }}
        />
      </Space>
    </Card>
  );
};

export default Users;
